function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.0627 3.1722C10.5661 2.15248 11.8415 1.71484 12.9113 2.19471C13.2976 2.36801 13.6193 2.64673 13.8369 2.99338L13.9368 3.1722L21.7957 19.0905C22.2992 20.1102 21.84 21.3259 20.7702 21.8058C20.5421 21.9081 20.2973 21.971 20.0471 21.9921L19.8587 22H4.14082C2.95848 22 2 21.0864 2 19.9594C2 19.7191 2.04453 19.4812 2.13105 19.2564L2.20377 19.0905L10.0627 3.1722Z",
  fill: "#A9781C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 15V8M12 18.1V18",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

function SvgWarningStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningStatus);
export default __webpack_public_path__ + "static/media/warning_status.8ebd6cbf.svg";
export { ForwardRef as ReactComponent };